import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useAppState } from "../../contexts/App";
import Modal, { ModalButton, ModalSecondaryButton } from "../Modal";
import { PlusTag } from "../PlusTag";

type Props = {
  /** Name of the feature, shown in the title (e.g. "Sugestões com IA"). */
  feature: string;
  /** What the feature does, in one or two sentences. */
  description?: string;
  onClose: () => void;
};

/** Standard notice for PLUS-only features on a FREE Keepo, leading to the plans page. */
export const PlusOnlyModal = ({ feature, description, onClose }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { appState } = useAppState();

  return (
    <Modal
      tone="plus"
      outsideExit
      onExit={onClose}
      eyebrow={<PlusTag>✦ Keepo Plus</PlusTag>}
      title={t("components.plusOnlyModal.title", { feature })}
      subtitle={description || t("components.plusOnlyModal.description")}
      footer={
        <>
          <ModalSecondaryButton type="button" onClick={onClose}>
            {t("components.plusOnlyModal.dismiss")}
          </ModalSecondaryButton>
          <ModalButton variant="plus" onClick={() => navigate(`/subscription/features?site=${appState.editingSiteId}`)}>
            {t("components.plusOnlyModal.cta")}
          </ModalButton>
        </>
      }
    />
  );
};
